import { handleActions } from 'redux-actions';
const initalState = {};
export default handleActions({
    'there is no actions in this reducer': state => (Object.assign({}, state))
}, initalState);
